//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { AddIcon, EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Flex,
  Stack,
  Text,
  HStack,
} from "@chakra-ui/react";
import { Formik } from "formik";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react-lite";
import { arrayToString } from "../../../utils/functions";
import React, { useRef, useState } from "react";
import { object, string } from "yup";
import Pluralize from "pluralize";
import {
  OverlayWrapper,
  useOverlayDisclosure,
} from "../../../components/OverlayRouter";
import {
  DurationUrgency,
  LessonScheduleFormWithRef,
} from "../../../home-tutoring/parent-flow/forms/LessonScheduleForm";
import Dot from "../../../components/layout/Dot";
import { IRequestFlowStore } from "../../../stores";
import { ILessonScheduleStore } from "../../../stores/types";

const tutorIndex = {
  1: "First tutor",
  2: "Second tutor",
  3: "Third tutor",
  4: "Fourth tutor",
  5: "Fifth tutor",
  6: "Sixth tutor",
  7: "Seventh tutor",
  8: "Eighth tutor",
  9: "Ninth tutor",
  10: "Tenth tutor",
};
const LessonScheduleSummary: React.FC<{
  viewModel: ILessonScheduleStore;
  onEdit: (index?: any) => any;
  submitText?: string;
  loading?: boolean;
  onNextClick: () => void;
  splitInfo: {
    subjectGroup: string[];
    searchSubject: string[];
    students: string[];
  }[];
  [key: string]: any;
}> = observer(
  ({
    viewModel,
    onEdit,
    submitText = "Save",
    loading,
    onNextClick,
    splitInfo,
    ...rest
  }) => {
    const formikRef = useRef<any>(null);

    let validationSchema = object().shape({
      lessonDuration: string().required("Length of lessons?"),
      lessonUrgency: string().required("When to start?"),
    });

    const initialValue = {
      lessonDuration: viewModel.clientSchedule[0]?.lessonDuration,
      lessonUrgency: viewModel.clientSchedule[0]?.lessonUrgency,
    };

    const handleOnNextClick = async () => {
      const form = formikRef.current;
      await form.submitForm();
      if (Object.keys(form.state.errors).length <= 0) {
        const durationUrgency = form.state.values;
        viewModel.updateDurationUrgency(durationUrgency);
        onNextClick();
      }
    };

    return (
      <Stack spacing={3} {...rest}>
        <Text fontWeight="medium" fontSize="md">
          Add tutor schedules
        </Text>

        <Box borderWidth="2xs" rounded="fbRadius">
          {viewModel.clientSchedule.length > 0 &&
            viewModel.clientSchedule.map((schedule, index) => (
              <Box key={index}>
                <EachSchedule
                  index={index + 1}
                  schedule={schedule}
                  splitInfo={splitInfo[index]}
                  onEdit={() => onEdit(index)}
                />
                {index + 1 !== viewModel.clientSchedule.length && <hr />}
              </Box>
            ))}
        </Box>
        <Box pt={3}>
          <Formik
            validationSchema={validationSchema}
            initialValues={initialValue}
            onSubmit={() => {}}
            ref={formikRef as any}
          >
            {({ handleSubmit }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <DurationUrgency />
                </form>
              );
            }}
          </Formik>
        </Box>
        <Flex pt={3} justify="flex-end" align="center">
          <Button
            size="lg"
            width={["100%", "100%", "50%"]}
            onClick={handleOnNextClick}
            isDisabled={!viewModel.isValid}
            isLoading={loading}
            loadingText="Submitting"
            colorScheme="blue"
          >
            {submitText}
          </Button>
        </Flex>
      </Stack>
    );
  },
);

const LessonScheduleFormArray: React.FC<{
  onSubmit: any;
  loading?: boolean;
  onNextClick?: () => void;
  viewModel: ILessonScheduleStore;
  submitText?: string;
  updateFormIndex?: () => void;
  path?: string;
  splitInfo?: any;
  [key: string]: any;
}> = observer(
  ({
    onSubmit,
    spacing = "20px",
    loading,
    onNextClick = () => {},
    viewModel,
    submitText = "Save",
    updateFormIndex,
    path,
    splitInfo,
    ...rest
  }) => {
    const editFormInArray: any = useEditSingleForm("/detail");

    return (
      <Box className="lesson_schedule" {...rest}>
        <LessonScheduleSummary
          splitInfo={splitInfo}
          viewModel={viewModel}
          loading={loading}
          submitText={submitText}
          onEdit={(...rst) => {
            editFormInArray.onEdit(...rst);
            if (updateFormIndex) {
              updateFormIndex();
            }
          }}
          onNextClick={(...rst) => {
            onNextClick(...rst);
            if (updateFormIndex) {
              updateFormIndex();
            }
          }}
        />

        <OverlayWrapper
          key={editFormInArray.formIndex}
          exact={false}
          path={"/detail"}
        >
          <EachLessonScheduleDrawer
            onSaveEdit={(data) => {
              viewModel.replaceData(editFormInArray.formIndex, {
                ...data,
              });
            }}
            display={viewModel.display(editFormInArray.formIndex)}
            onRemove={() => viewModel.remove(editFormInArray.formIndex)}
            onAddSchedule={(data) => viewModel.addNewChild({ ...data })}
            values={viewModel.clientSchedule}
            {...editFormInArray}
          />
        </OverlayWrapper>
      </Box>
    );
  },
);

export default LessonScheduleFormArray;

const EachSchedule = observer(
  ({ schedule, onEdit = () => {}, index, splitInfo = {}, ...rest }: any) => {
    const {
      lessonDays = [],
      lessonHours,
      lessonTime,
      lessonDuration,
    } = schedule;

    const subjects = Array.from(
      new Set([splitInfo.searchSubject, ...splitInfo.subjectGroup]),
    );

    const otherSubjects =
      subjects.length > 2
        ? `and ${Pluralize("subjects", subjects.length - 2, true)}`
        : "";

    return (
      <Flex
        justify="space-between"
        align="center"
        py={[3, 4]}
        px={[4, 5]}
        {...rest}
      >
        <Box fontSize="sm" flex={1}>
          <Text mb={1} fontWeight="semibold">
            {tutorIndex[index]}
          </Text>
          {lessonDays.length ? (
            <Text opacity="0.8" fontSize="sm">
              {Pluralize("day", lessonDays.length, true)} weekly &{" "}
              {Pluralize("hour", lessonHours, true)} per lesson.{" "}
              {arrayToString(subjects.slice(0, 2))}
            </Text>
          ) : (
            <Text opacity="0.8" fontSize="sm">
              For {arrayToString(splitInfo.students)} in{" "}
              {subjects.slice(0, 2).join(", ")} {otherSubjects}
            </Text>
          )}
        </Box>

        {lessonDays.length ? (
          <Button
            size="sm"
            leftIcon={<EditIcon />}
            variant="ghost"
            ml={[3, 8]}
            colorScheme="blue"
            onClick={onEdit}
          >
            Edit
          </Button>
        ) : (
          <Button
            size="sm"
            leftIcon={<AddIcon />}
            variant="ghost"
            ml={[3, 8]}
            colorScheme="blue"
            onClick={onEdit}
          >
            Add
          </Button>
        )}
      </Flex>
    );
  },
);

const EachLessonScheduleDrawer = observer(
  ({
    values = [],
    formIndex,
    onSaveEdit = () => {},
    onAddSchedule = () => {},
    display = "",
    isOpen,
    onClose = () => {},
    path,
  }: any) => {
    let scheduleData = formIndex >= 0 ? values[formIndex] : undefined;
    const formikFormRef = useRef<any>();
    const [value, setValue] = useState(scheduleData);

    React.useEffect(() => {
      setValue(scheduleData);
    }, [scheduleData]);

    function OverrideOnSaveEdit(value) {
      if (formIndex >= 0) onSaveEdit(value);
      if (formIndex === null) onAddSchedule(value);
    }

    const handleSave = () => {
      const form = formikFormRef.current;
      form.submitForm();
      if (isEmpty(formikFormRef.current.state.errors)) {
        OverrideOnSaveEdit(form.state.values);
        onClose();
      }
    };

    const handleCloseClick = () => {
      onClose();
    };

    return (
      <Modal
        isOpen={isOpen}
        onClose={handleCloseClick}
        size="lg"
        scrollBehavior="inside"
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent
          overflow={"hidden"}
          rounded="fbRadius"
          mx={2}
          className="child-form-Modal"
        >
          <ModalCloseButton />
          <ModalHeader fontWeight="bold" borderBottomWidth={"2xs"}>
            <Box>{display} tutor schedule</Box>
          </ModalHeader>
          <ModalBody py={8}>
            <LessonScheduleFormWithRef
              path={path}
              onSubmit={(data) => setValue(data)}
              ref={formikFormRef}
              value={value}
            />
          </ModalBody>
          <ModalFooter bg="neutral.50" display="block" borderTopWidth="2xs">
            <Flex align="center" justify="space-between">
              <Button variant="outline" size="lg" onClick={handleCloseClick}>
                Cancel
              </Button>
              <Button
                type="submit"
                size="lg"
                onClick={handleSave}
                colorScheme="blue"
              >
                Save
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  },
);

function useEditSingleForm(path) {
  const [formIndex, setFormIndex] = useState(null);
  //   const { isOpen, onClose, onOpen } = useDisclosure();
  const { isOpen, onClose, onOpen } = useOverlayDisclosure(path);

  function onEdit(index) {
    setFormIndex(index);
    onOpen();
  }

  return { onOpen, isOpen, onClose, onEdit, formIndex, path };
}
